import React, { useEffect } from "react";

export default function MobileMenuDrawer({
  open,
  onClose,
  onOpenAuth,
  onSelectMenuItem,
  isLoggedIn,
  onLogout,
}) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose?.();
    }
    if (!open) return undefined;
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const items = ["Home", "About", "Subscription", "Profile", "Contact", "Terms & Conditions", "FAQ"];

  return (
    <div className="fixed inset-0 z-50">
      <button
        type="button"
        aria-label="Close menu"
        onClick={onClose}
        className="absolute inset-0 bg-black/25"
      />

      <aside className="absolute right-0 top-0 h-full w-72 rounded-l-3xl bg-white shadow-2xl border-l border-slate-200">
        <div className="flex items-center justify-end px-4 py-3">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-11 w-11 items-center justify-center rounded-full p-0 text-slate-600 hover:bg-[#F5F7FB] ring-1 ring-slate-200"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <nav className="px-5 pb-5 text-sm text-slate-700">
          <ul className="space-y-3">
            {items.map((label) => (
              <li key={label}>
                <button
                  type="button"
                  className="w-full rounded-2xl px-3 py-2 text-left text-[#24303A] font-semibold hover:bg-[#F5F7FB]"
                  onClick={() => {
                    onSelectMenuItem?.(label.toLowerCase());
                    onClose?.();
                  }}
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>

          <div className="my-4 h-px bg-slate-200" />

          <div className="space-y-2">
            {isLoggedIn ? (
              <button
                type="button"
                className="w-full rounded-xl border border-femty-primary bg-femty-primary px-3 py-2 text-sm font-semibold text-white hover:bg-femty-primary-hover"
                onClick={() => {
                  onLogout?.();
                }}
              >
                Logout
              </button>
            ) : (
              <>
                <button
                  type="button"
                  className="w-full rounded-xl border border-femty-primary/30 bg-white px-3 py-2 text-sm font-semibold text-femty-text hover:border-femty-primary hover:text-femty-primary"
                  onClick={() => {
                    onClose?.();
                    onOpenAuth?.("login");
                  }}
                >
                  Login
                </button>
                <button
                  type="button"
                  className="w-full rounded-xl border border-femty-primary bg-femty-primary px-3 py-2 text-sm font-semibold text-white hover:bg-femty-primary-hover"
                  onClick={() => {
                    onClose?.();
                    onOpenAuth?.("signup");
                  }}
                >
                  Sign up
                </button>
              </>
            )}
          </div>
        </nav>
      </aside>
    </div>
  );
}

